<template>
  <div class="header-wrapper">
    <div
      id="dmm_ntgnavi"
      v-if="isDMM"
    >
      <ul class="navi_left">
        <li class="dmm_top mg-l12">
          <a href="http://www.dmm.com/">
            <img
              src="https://www.dmm.com/images/netgame/navi/dmm_logo.gif"
              alt="DMM.com"
            />
          </a>
        </li>
        <li class="ntg_top">
          <a href="http://www.dmm.com/netgame/">
            <span>DMM GAMESトップ</span>
          </a>
        </li>
        <li class="ntg_poi">
          <a
            href="https://point.dmm.com/choice/pay?basket_service_type=freegame"
            target="_blank"
          >
            <span>ポイントチャージ</span>
          </a>
        </li>
      </ul>
      <ul class="navi_right">
        <li>
          <a
            href="http://www.dmm.com/netgame/top/guide/startguide_html/=/ch_navi=/"
            class="arrow"
          >初めての方</a>
        </li>
      </ul>
      <div class="clear"></div>
    </div>
    <div
      class="header"
      v-else
    >
      <div class="header-content">
        <i class="logo"></i>
        <div class="header-account">
          <a
            class="link-btn tw j-twi-btn"
            target="_blank"
            :href="pageInfo.header_twi"
            v-if="pageInfo.header_twi"
          ></a>
          <a
            class="link-btn fb j-fb-btn"
            target="_blank"
            :href="pageInfo.header_fb"
            v-if="pageInfo.header_fb"
          ></a>
          <a
            href="//gpassport.37games.com/center/JpServicePrivicy/privicy"
            target="_blank"
            class="btn"
          >プライバシーポリシー</a>
          <a
            class="btn j-download"
            @click="excDownload"
          >
            <i class="download"></i>
            <span>{{ letter.download }}</span>
          </a>
          <a
            class="btn j-favour"
            href="javascript:;"
            @click="excFavour"
          >
            <i class="favour"></i>
            <span>{{ letter.favour }}</span>
          </a>
          <span
            class="name"
            v-show="isLogin"
            v-html="accountName"
          ></span>
          <i
            class="gift-icon"
            @click="handleGiftIconClick"
            v-if="showGiftIcon"
          ></i>
          <transition name="fade">
            <div
              class="tips"
              v-show="showTips"
            >
              <img :src="pageInfo.tips_bg" />
              <p
                :style="fontCss"
                v-html="favourDownloadTips"
              ></p>
              <i
                class="close-tip"
                @click="closeTips"
              ></i>
            </div>
          </transition>
        </div>
      </div>
      <transition name="fade">
        <div
          class="guide-mask"
          v-if="showGuidePopup"
        >
          <div class="guide-popup">
            <div
              @click="closePopup('guide')"
              class="guide-close"
            ></div>
            <div
              @click="closePopup('guide')"
              class="guide-confirm"
            ></div>
          </div>
        </div>
      </transition>
      <transition name="fade">
        <div
          class="guide-mask"
          v-if="showGiftPopup"
        >
          <div class="gift-popup">
            <select
              class="gift-popup-select server"
              name="server"
              v-model="selectServer"
            >
              <option
                value
                disabled
                hidden
              >サーバーを選ぶ</option>
              <option
                v-for="item in serverList"
                :key="item.ID"
                :value="item.ID"
              >{{ item.NAME || item.REAL_NAME }}</option>
            </select>
            <select
              class="gift-popup-select role"
              name="role"
              v-model="selectRole"
            >
              <option
                value
                disabled
                hidden
              >キャラクターを選ぶ</option>
              <option
                v-for="item in roleList"
                :key="item.roleID"
                :value="item.roleID"
              >{{ item.roleName }}</option>
            </select>
            <div
              @click="closePopup('gift')"
              class="gift-close"
            ></div>
            <div
              @click="handleGiftClick"
              class="gift-confirm"
            ></div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import {
  RESET_DATA,
  GET_ROLE_LIST,
  GET_REWARD_INFO,
  AWARD_GIFT,
  CLICK_DATAIN,
  VISIT_LOG,
  GET_UUID,
} from "../store/web/h5";
import { mapGetters } from "vuex";
import globalConfig from "../utiles/globalConfig";
import h5Sdk from "../mixins/h5Sdk";
import favour from "../mixins/favour";
import download from "../mixins/download";
import { HREF_IS_DMM } from "../store/web/h5";
export default {
  name: "h5header",
  mixins: [h5Sdk, favour, download],
  data() {
    return {
      showTips: false,
      showGuidePopup: false,
      showGiftPopup: false,
      selectServer: "",
      selectRole: "",
      isDMM: HREF_IS_DMM,
      pageInfo: window.pageInfo,
      fontCss: `color:${window.pageInfo.color.font}`,
    };
  },
  computed: {
    favourDownloadTips() {
      return window.pageInfo.tips_text || this.letter.favourAndDownloadTip;
    },
    userPhoto() {
      return this.$store.state.login.userPhoto;
    },
    favourTip() {
      return `javascript:alert("${this.letter.favourTip}")`;
    },
    tipsBg() {
      return this.$store.state.tipsBg;
    },
    ...mapGetters([
      "letter",
      "isLogin",
      "accountName",
      "serverList",
      "roleList",
      "isExe",
      "isAward",
    ]),
    showGiftIcon() {
      // 如果是微端发奖+没领奖+是微端才显示这个icon
      return this.isExe && !this.isAward && window.pageInfo.award.exe;
    },
  },
  created() {
    this.fetchBaseInfo();
    let isTips = parseInt(
      globalConfig.getLclStorageItem("isFavourAndDownloadTip"),
      10
    );
    if (isTips) {
      let lastTime = globalConfig.getLclStorageItem("favourAndDownloadTipTime");
      let nowTime = new Date().getTime();
      let day = parseInt((nowTime - lastTime) / (1000 * 60 * 60 * 24));
      if (day > 0) {
        this.readyShowTip();
      }
    } else {
      this.readyShowTip();
    }
    // 获取uuid，统计pv，uv
    this.getFingerprint()
      .then((res) => {
        this.$store.dispatch(VISIT_LOG, res);
      })
      .catch((res) => {
        this.$store.dispatch(GET_UUID).then((res) => {
          this.$store.dispatch(VISIT_LOG, res);
        });
      });
  },
  watch: {
    selectServer(newVal) {
      this.$store.dispatch(GET_ROLE_LIST, newVal);
    },
    roleList(arr) {
      this.$nextTick(() => {
        if (arr.length) {
          this.selectRole = arr[0].roleID;
        }
      });
    },
  },
  methods: {
    excDownload() {
      this.downloadFn();
      if (window.pageInfo.award.exe) {
        this.showGuidePopup = true;
        this.collectData("download");
      }
    },
    excFavour() {
      this.favourFn();
      if (window.pageInfo.award.exe) {
        this.collectData("favour");
      }
    },
    closeTips() {
      this.showTips = false;
    },
    readyShowTip() {
      setInterval(() => {
        this.showTips = true;
        globalConfig.setLclStorageItem("isFavourAndDownloadTip", 1);
        globalConfig.setLclStorageItem(
          "favourAndDownloadTipTime",
          new Date().getTime()
        );
      }, 1000 * 60 * 3);
    },
    fetchBaseInfo() {
      this.$store.dispatch(GET_REWARD_INFO, {
        time: globalConfig.getHrefParam("time") || "",
        sign: globalConfig.getHrefParam("sign") || "",
      });
    },

    collectData(type) {
      let buttonName = `${type}-btn${this.isExe ? "&&isExe" : ""}`;
      this.$store.dispatch(CLICK_DATAIN, buttonName);
    },
    closePopup(type) {
      if (type === "guide") {
        this.showGuidePopup = false;
      } else if (type === "gift") {
        this.showGiftPopup = false;
      }
    },
    handleGiftIconClick() {
      this.showGiftPopup = true;
    },
    handleGiftClick() {
      this.$store
        .dispatch(AWARD_GIFT, {
          sid: this.selectServer,
          roleId: this.selectRole,
        })
        .then((res) => {
          res = res.res;
          if (+res.code === 1) {
            this.showGiftPopup = false;
            this.fetchBaseInfo();
            alert("賞を受賞しました");
          } else {
            let codeTips = {
              "-20001": "ログインしていません",
              "-20002": "報酬を受け取った",
              "-20003": "賞を受け取れませんでした",
              "-20004": "最初にマイクロ端末からログインしてください",
            };
            alert(
              codeTips[+res.code] ||
                "システムエラー、しばらくしてからもう一度お試しください"
            );
          }
        });
    },
  },
};
</script>
